module.exports = "<h2 id=\"news\">NEWS</h2>\n<br>\n\n\n";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy/news_en.md
// module id = u5BH
// module chunks = 0